__turbopack_context__.v({
  "content": "_2bHExG_content",
  "contentHeadline": "_2bHExG_contentHeadline",
  "contentText": "_2bHExG_contentText",
  "ctaButton": "_2bHExG_ctaButton",
  "description": "_2bHExG_description",
  "descriptionBlock": "_2bHExG_descriptionBlock",
  "headline": "_2bHExG_headline",
  "hiddenWidgetContainer": "_2bHExG_hiddenWidgetContainer",
  "imageWrapper": "_2bHExG_imageWrapper",
  "intro": "_2bHExG_intro",
  "loggedIn": "_2bHExG_loggedIn",
  "loginButton": "_2bHExG_loginButton",
  "recommendationWidget": "_2bHExG_recommendationWidget",
  "richTextHeadline": "_2bHExG_richTextHeadline",
});
